import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../../styles/spa.css";
import Logo from "../../assets/images/logo-with-text.png";
import { CircularProgress } from "@material-ui/core";
import withMiddleware from "../../middleware";
import { useHistory } from "react-router-dom";
import { getInvitationDetails, processInvitation } from "./handler";
// import { routeAfterLoginOrSignup, getRoutes } from "../auth/login/handler";
import { logoutUser } from "../../actions";
import { showToast } from "../../utils/toast";

function Invitation(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [inviteDetails, setInviteDetails] = useState();
  const history = useHistory();
  const { user } = useSelector((state) => ({
    user: state.app.user,
  }));
  const dispatch = useDispatch();

  const invite_token = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const invite_token = params.get("it");
    return invite_token;
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);

        if (!invite_token) {
          setInviteDetails({ error: "Invitation link is not valid!!" });
          return;
        }
        // const details = await getInvitationDetails(props.service, invite_token);
        // debugger;
        // if (!details?.accountSameAsEmail) {
        //   setInviteDetails({
        //     error: `The email address you used to access the invitation does not match the one the invitation was sent to. Please ensure you are signed in with the correct account associated with the invitation.\nIf needed, you can also request the sender to resend the invitation to your current account email <b>${user?.email}</b>`,
        //   });
        //   return;
        // }
        // setInviteDetails(details);
      } catch (err) {
        setInviteDetails(err);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [user?.email, invite_token]);

  const handleProcessInvitation = async () => {
    try {
      setIsLoading(true);
      await processInvitation(props.service, invite_token);
      routeAfterDecision();
    } catch (error) {
      showToast("error", error?.error || error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const routeAfterDecision = () => {
    // TODO: Route user to the instructions page.
    // const route = getRoutes(user?.user_type);
    // routeAfterLoginOrSignup(history, route, user);
    history.push("/welcome", { user });
  };
  return (
    <div id="invitation-container">
      <img src={Logo} className="app-logo" alt="OptimalHRV Logo" />
      {/* <div className="top-right-ele" onClick={routeAfterDecision}>
        <span>
          <b>Skip for now</b>
        </span>
      </div> */}
      <div className="content">
        {isLoading ? (
          <CircularProgress size={60} />
        ) : !inviteDetails?.error ? (
          <>
            <h3 className="title">Thank you for purchasing the Lifetime Membership!</h3>
            <p>
              Please confirm that you would like to activate your Lifetime Membership on this account.
              <br />
              <strong>
                <i>Note: Once the membership is claimed on this account, it cannot be transferred or activated on any other account.</i>
              </strong>
            </p>
            <div className="actions">
              <button onClick={() => handleProcessInvitation()} className="green">
                Claim Now
              </button>
            </div>
          </>
        ) : (
          <>
            <h1
              style={{
                margin: 0,
              }}
            >
              Something went wrong!
            </h1>
            <p dangerouslySetInnerHTML={{ __html: inviteDetails?.error || "Sorry the claim link does not seem to be valid!!" }} />
          </>
        )}
        <div className="account-selection">
          <span>
            You are logged in as:{"  "}
            <b>
              {user?.first_name} {user?.last_name} | {user?.email}
            </b>
          </span>
          <div className="logout-section">
            <span>Want to claim through another account?</span>
            <div
              className="logout"
              onClick={() => {
                dispatch(logoutUser());
              }}
            >
              <b>Logout</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withMiddleware(Invitation);
